import React from "react";
import "./Header.scss";
import { motion } from "framer-motion";
import images from "../../constants/images";
import AppWrap from "../../wrapper/AppWrap";
import MotionWrap from "../../wrapper/MotionWrap";
// import { useSelector } from "react-redux";

const Header = () => {
  const scaleVarients = {
    whileInView: {
      scale: [0, 1],
      opacity: [0, 1],
      transition: {
        duration: 1,
        ease: "easeInOut",
      },
    },
  };

  // const isDarkTheme = useSelector((state) => state.theme.isDarkTheme);

  return (
    <div className={`${"app__header"} app__flex`}>
      <motion.div
        whileInView={{ x: [-100, 0], opacity: [0, 1] }}
        transition={{ duration: 0.8 }}
        className="app__header-info"
      >
        <div className={`${"app__header-badge"}`}>
          <div className="badge-cmp app__flex">
            <span>👋</span>
            <div style={{ marginLeft: 20 }}>
              <p className="p-text">hello, I am</p>
              <h1 className={`${"head-text"}`}>Prathmesh</h1>
            </div>
          </div>

          <div className="tag-cmp app__flex">
            <p className="p-text">Developer</p>
            <p className="p-text"></p>
          </div>
        </div>
      </motion.div>

      <motion.div
        whileInView={{ opacity: [0, 1] }}
        transition={{ duration: 0.8, delayChildren: 0.5 }}
        className="app__header-img"
      >
        <img src={images.profile} alt="profile-bg" />
        <motion.img
          whileInView={{ scale: [0, 1] }}
          transition={{ duration: 1, ease: "easeInOut" }}
          className="overlay_circle"
          src={images.circle}
          alt="profile_circle"
        />
      </motion.div>

      <motion.div
        variant={scaleVarients}
        whileInView={scaleVarients.whileInView}
        className="app__header-circles"
      ></motion.div>
    </div>
  );
};

export default AppWrap(MotionWrap(Header), "home");
